import { defineMessages } from 'react-intl';

export default defineMessages({
  ClearButton: {
    defaultMessage: 'Clear',
    description: 'Autocomplete clear button',
    id: 'autocompleteChips.ClearButton',
  },
});
